import { render, staticRenderFns } from "./dataBoxSimple.vue?vue&type=template&id=9142c492&scoped=true"
import script from "./dataBoxSimple.vue?vue&type=script&lang=ts"
export * from "./dataBoxSimple.vue?vue&type=script&lang=ts"
import style0 from "./dataBoxSimple.vue?vue&type=style&index=0&id=9142c492&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9142c492",
  null
  
)

export default component.exports